'use strict'
import errorService from '@/services/errorService'

var config, service, configurazioni;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  configurazioni = config.VUE_APP_MOL_S_CONFIGURATIONS
}

async function getToken() {
   if (!config || !service) {
    await getConfigFile();
  }
  // construire la audience in base ai pacchetti necessari
  const audience = 'configurazioni,prodotti,base'
  try {
    const response = await fetch(`${service}/${configurazioni}/token?aud=${audience}&from=backoffice`)
    /*     const response = await fetch(`${service}/${configurazioni}/token?aud=${audience}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }) */
    return await response.json()
  } catch (error) {
    console.log('error getToken', error)
    errorService.onError(error, 'getToken')
    return ''
  }
}

async function verifyToken(token) {
   if (!config || !service) {
    await getConfigFile();
  }
  if (!token) return { stato: 'token.scaduto' }
  if (token === 'Licenza scaduta') return { stato: 'licenza.scaduta' }
  let licenza = {}
  try {
    const response = await fetch(`${service}/${configurazioni}/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
      // body: JSON.stringify({ token }) // verificare se necessario o è possibile prenderlo dal Bearer
    })
    const result = await response.json()
    licenza = result
  } catch (err) {
    // verificare risposta in base a token (es. scaduto)
    // console.log(err)
    licenza.stato = 'token.scaduto'
  }

  return licenza
}

async function getTokenDispositivo() {
   if (!config || !service) {
    await getConfigFile();
  }
  // construire la audience in base ai pacchetti necessari
  const audience = 'dashboard, picking'
  try {
    const response = await fetch(`${service}/${configurazioni}/token/dispositivo?aud=${audience}`)
    return await response.json()
  } catch (error) {
    console.log('error getTokenDispositivo', error)
    errorService.onError(error, 'getTokenDispositivo')
    return ''
  }
}

async function login(utente) {
   if (!config || !service) {
    await getConfigFile();
  }
  try {
    var data = {
      utente
    }
    const response = await fetch(`${service}/${configurazioni}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return { error: 'Errore login: ' + err.message}
  }
}

export default {
  getToken,
  verifyToken,
  getTokenDispositivo,
  login
}
